"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCellValueByGanttDateTimeFieldId = exports._getLookUpTreeValue = exports.getEntityCellValue = exports.getFormulaCellValue = exports.getComputeCellValue = exports.calcCellValue = exports.getStringifyCellValue = exports.calcCellValueAndString = exports.getCellValue = void 0;
const cache_manager_1 = require("../../../../../../cache_manager");
const compute_manager_1 = require("../../../../../../compute_manager");
const interfaces_1 = require("../../../../../../exports/store/interfaces");
const formula_parser_1 = require("../../../../../../formula_parser");
const model_1 = require("../../../../../../model");
const field_types_1 = require("../../../../../../types/field_types");
const base_1 = require("./base");
const workerCompute = () => global.useWorkerCompute;
/**
 * get cell value
 *
 * @param state
 * @param snapshot
 * @param recordId
 * @param fieldId
 * @param withError
 * @param datasheetId
 * @param ignoreFieldPermission
 * @returns
 */
const getCellValue = (state, snapshot, recordId, fieldId, withError, datasheetId, ignoreFieldPermission) => {
    // TODO: temp code for the first version of column permission, delete this logic in next version
    const fieldPermissionMap = (0, base_1.getFieldPermissionMap)(state, snapshot.datasheetId);
    const fieldRole = (0, base_1.getFieldRoleByFieldId)(fieldPermissionMap, fieldId);
    if (!ignoreFieldPermission && fieldRole === interfaces_1.Role.None) {
        return null;
    }
    const dsId = datasheetId || snapshot.datasheetId || state.pageParams.datasheetId;
    const calc = () => {
        return (0, exports.calcCellValueAndString)({
            state,
            snapshot,
            fieldId,
            recordId,
            datasheetId: dsId,
            withError,
            ignoreFieldPermission,
        });
    };
    if (!dsId) {
        return calc().cellValue;
    }
    const cacheValue = cache_manager_1.CacheManager.getCellCache(dsId, fieldId, recordId);
    if (cacheValue !== cache_manager_1.NO_CACHE) {
        return cacheValue.cellValue;
    }
    const res = calc();
    if (!res.ignoreCache) {
        cache_manager_1.CacheManager.setCellCache(dsId, fieldId, recordId, res);
    }
    return res.cellValue;
};
exports.getCellValue = getCellValue;
const calcCellValueAndString = ({ state, snapshot, fieldId, recordId, datasheetId, withError, ignoreFieldPermission, }) => {
    const cellValue = (0, exports.calcCellValue)(state, snapshot, fieldId, recordId, withError, datasheetId, ignoreFieldPermission);
    const fieldMap = snapshot.meta.fieldMap;
    const field = fieldMap[fieldId];
    if (cellValue == null) {
        return {
            cellValue,
            cellStr: null,
            ignoreCache: true,
        };
    }
    if (field.type === field_types_1.FieldType.Attachment) {
        return {
            cellStr: cellValue.map(item => item.name).join(','),
            cellValue,
            ignoreCache: workerCompute() ? false : true,
        };
    }
    const instance = model_1.Field.bindContext(field, state);
    return {
        cellValue,
        cellStr: instance.cellValueToString(cellValue),
        ignoreCache: workerCompute() ? false : !instance.isComputed,
    };
};
exports.calcCellValueAndString = calcCellValueAndString;
const getStringifyCellValue = (state, snapshot, recordId, fieldId, _withFilter, withError) => {
    const dsId = snapshot.datasheetId || state.pageParams.datasheetId;
    if (!dsId) {
        return (0, exports.calcCellValueAndString)({ state, snapshot, recordId, fieldId, withError }).cellStr;
    }
    let cacheValue = cache_manager_1.CacheManager.getCellCache(dsId, fieldId, recordId);
    if (cacheValue !== cache_manager_1.NO_CACHE) {
        return cacheValue.cellStr;
    }
    cacheValue = (0, exports.calcCellValueAndString)({ state, snapshot, recordId, fieldId, withError, datasheetId: dsId });
    if (!cacheValue.ignoreCache) {
        cache_manager_1.CacheManager.setCellCache(dsId, fieldId, recordId, cacheValue);
    }
    return cacheValue.cellStr;
};
exports.getStringifyCellValue = getStringifyCellValue;
// information of calculated cell
const calcCellValue = (state, snapshot, fieldId, recordId, withError, datasheetId, 
// TODO: for first version of column permission, delete this field in next version
ignoreFieldPermission) => {
    const fieldMap = snapshot.meta.fieldMap;
    const field = fieldMap[fieldId];
    // TODO: temp code for the first version of column permission, delete this logic in next version
    const fieldPermissionMap = (0, base_1.getFieldPermissionMap)(state, snapshot.datasheetId);
    const fieldRole = (0, base_1.getFieldRoleByFieldId)(fieldPermissionMap, fieldId);
    if (!ignoreFieldPermission && fieldRole === interfaces_1.Role.None) {
        return null;
    }
    if (!field) {
        return null;
    }
    const instance = model_1.Field.bindContext(field, state);
    if (instance.isComputed) {
        try {
            let cv = (0, exports.getComputeCellValue)(state, snapshot, recordId, fieldId, withError);
            cv = (0, model_1.handleEmptyCellValue)(cv, instance.basicValueType);
            return cv;
        }
        catch (error) {
            console.warn('! ' + error);
        }
    }
    return (0, exports.getEntityCellValue)(state, snapshot, recordId, fieldId, datasheetId);
};
exports.calcCellValue = calcCellValue;
const getComputeCellValue = (state, snapshot, recordId, fieldId, withError) => {
    const recordMap = snapshot.recordMap;
    const fieldMap = snapshot.meta.fieldMap;
    const field = fieldMap[fieldId];
    const record = recordMap[recordId];
    if (!field || !record) {
        return null;
    }
    switch (field.type) {
        case field_types_1.FieldType.Formula: {
            return (0, exports.getFormulaCellValue)(state, field, record, withError);
        }
        case field_types_1.FieldType.LookUp: {
            return model_1.Field.bindContext(field, state).getCellValue(recordId, withError);
        }
        case field_types_1.FieldType.CreatedBy:
        case field_types_1.FieldType.LastModifiedBy:
        case field_types_1.FieldType.CreatedTime:
        case field_types_1.FieldType.LastModifiedTime: {
            if (!record) {
                return null;
            }
            return model_1.Field.bindContext(field, state).getCellValue(record);
        }
        case field_types_1.FieldType.AutoNumber: {
            if (!record) {
                return null;
            }
            return model_1.Field.bindContext(field, state).getCellValue(record, fieldId);
        }
        default:
            return null;
    }
};
exports.getComputeCellValue = getComputeCellValue;
const getFormulaCellValue = (state, field, record, withError) => {
    return (0, formula_parser_1.evaluate)(field.property.expression, { field, record, state }, withError, false);
};
exports.getFormulaCellValue = getFormulaCellValue;
/**
 *
 * non-calc field value, get by record.data and fieldId
 *
 * @param state
 * @param snapshot
 * @param recordId
 * @param fieldId
 * @param datasheetId
 * @returns
 */
const getEntityCellValue = (state, snapshot, recordId, fieldId, datasheetId) => {
    var _a;
    const recordMap = snapshot.recordMap;
    const fieldMap = snapshot.meta.fieldMap;
    const field = fieldMap[fieldId];
    // TODO: if cannot find this id when get entity cell value,
    // it means that the server missed the data. The frontend needs to add a remedy to actively load the missing fields.
    if (!recordMap[recordId] && datasheetId) {
        const client = (_a = state.datasheetMap[datasheetId]) === null || _a === void 0 ? void 0 : _a.client;
        const loadingRecord = client === null || client === void 0 ? void 0 : client.loadingRecord;
        if (!(loadingRecord === null || loadingRecord === void 0 ? void 0 : loadingRecord[recordId])) {
            compute_manager_1.dataSelfHelper.addRecord(datasheetId, recordId, fieldId);
        }
    }
    const recordData = recordMap[recordId] && recordMap[recordId].data;
    if (!field || !recordData) {
        return null;
    }
    let cv = recordData[fieldId];
    cv = (0, model_1.handleEmptyCellValue)(cv, model_1.Field.bindContext(field, state).basicValueType);
    return cv;
};
exports.getEntityCellValue = getEntityCellValue;
const _getLookUpTreeValue = (state, snapshot, recordId, fieldId, datasheetId) => {
    const fieldMap = snapshot.meta.fieldMap;
    const field = fieldMap[fieldId];
    if (!field) {
        return null;
    }
    if (model_1.Field.bindContext(field, state).isComputed) {
        if (field.type === field_types_1.FieldType.LookUp) {
            return new model_1.LookUpField(field, state).getLookUpTreeValue(recordId);
        }
        return (0, exports.getComputeCellValue)(state, snapshot, recordId, fieldId);
    }
    return (0, exports.getEntityCellValue)(state, snapshot, recordId, fieldId, datasheetId);
};
exports._getLookUpTreeValue = _getLookUpTreeValue;
const getCellValueByGanttDateTimeFieldId = (state, snapshot, recordId, fieldId) => {
    const fieldMap = snapshot.meta.fieldMap;
    const field = fieldMap[fieldId];
    if (field == null) {
        return null;
    }
    if (model_1.Field.bindContext(field, state).basicValueType === field_types_1.BasicValueType.DateTime) {
        return (0, exports.getCellValue)(state, snapshot, recordId, field.id);
    }
    if (model_1.Field.bindContext(field, state).innerBasicValueType === field_types_1.BasicValueType.DateTime) {
        const cellValue = (0, exports.getCellValue)(state, snapshot, recordId, field.id);
        if (cellValue === null || cellValue === void 0 ? void 0 : cellValue.length) {
            return cellValue[0];
        }
    }
    return null;
};
exports.getCellValueByGanttDateTimeFieldId = getCellValueByGanttDateTimeFieldId;
//# sourceMappingURL=cell_calc.js.map